interface IAddressFields {
  homeAddressLine1: string;
  homeAddressLine2: string;
  homeAddressCity: string;
  homeAddressState: string;
  homeAddressPostcode: string;
}

const formatAddress = ({
  homeAddressLine1,
  homeAddressLine2,
  homeAddressCity,
  homeAddressState,
  homeAddressPostcode,
}: IAddressFields): string =>
  [homeAddressLine1, homeAddressLine2, homeAddressCity, homeAddressState, homeAddressPostcode]
    .map(value => value.trim())
    .filter(Boolean)
    .join(', ');

export { formatAddress };
export type { IAddressFields };
